import React, { useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { EmailValue } from "../../../initialValues/authenticationVal";
import { EmailSchema } from "../../../lib/validations/uservalidation";
import { resetPassword } from "../../../apis/otpVerify";
import { StorageToken } from "../../../apis/loginApi";
const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: EmailValue,
    validationSchema: EmailSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const res = await resetPassword(values);
        if (res.data.success === true) {
          setLoading(false);
          setSuccessMessage(res.data.result.maskEmail);
          await StorageToken({ email: values.email });
          navigate("/otp");
        } else if (res.data.success === false) {
          setErrorMessage(res.data.message);
          setLoading(false);
        }
      } catch (err) {
        setErrorMessage("An error occurred while enter the email");
        setLoading(false);
      }
    },
  });

  const handleChange = (e) => {
    const value = e.target.value;
    formik.setFieldValue("email", value.toLowerCase());
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">Forgot Password?</h3>
                <p className="account-subtitle">
                  Enter your email to get a password reset link
                </p>
                {(errorMessage || successMessage) && (
                  <p
                    className={
                      errorMessage !== ""
                        ? "text-danger text-center"
                        : successMessage !== ""
                        ? "text-success text-center"
                        : ""
                    }
                    style={{ fontSize: "25px" }}
                  >
                    {errorMessage || successMessage}
                  </p>
                )}
                <form onSubmit={formik.handleSubmit}>
                  <div className="input-block">
                    <label>Email Address</label>
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      name="email"
                      placeholder="Enter Your Email"
                
                      //   value={formik.values.email}
                      value={formik.values.email}
                      onChange={handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="text-danger">{formik.errors.email}</div>
                    )}
                  </div>
                  <div className="input-block text-center">
                    {loading ? (
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <button
                        className="btn btn-primary account-btn"
                        type="submit"
                      >
                        Send Password
                      </button>
                    )}
                  </div>
                  <div className="account-footer">
                    <p>
                      Remember your password?{" "}
                      <Link to="/" className="text-primary">
                        Login
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
